define("shared/components/shared/linkinbio/list/multi-link", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="o--modalBody--secondary u--p__0 has--footer" {{perfect-scroll}}>
    <ul class="u--listUnstyle">
      {{#each @links as |multiLink index|}}
        <li class="o--list__item u--p__0">
          <Shared::Ui::Button
            @additional="block"
            @class="cML--list__item"
            @onClick={{action @editLink multiLink}}
            @variant="unstyled"
          >
            <div class="cML--list__bullet">
              <span class="cML--list__bullet--counter">
                {{add index 1}}
              </span>
              <Shared::Ui::Button
                @class="cML--list__bullet--action qa--linkinbio_delete_link u--hide--mobile"
                @onClick={{action @toggleDeleteLink multiLink}}
                @variant="unstyled"
              >
                {{svg-jar "trash" class="o--icon qa--linkinbio_delete_icon"}}
              </Shared::Ui::Button>
            </div>
  
            <h4 class="o--list__title u--ellipsis">
              {{multiLink.title}}
            </h4>
            <p class="o--list__text">
              {{multiLink.linkUrl}}
            </p>
            <a class="o--list__action u--text--uppercase">
              {{t "shared_words.edit"}}
            </a>
            <Shared::Ui::Button
              @class="cML--list__bullet--mobAction qa--linkinbio_delete_link u--hide--desktop o--list__action"
              @onClick={{action @toggleDeleteLink multiLink}}
              @variant="unstyled"
            >
              {{svg-jar "trash" class="o--icon qa--linkinbio_delete_icon"}}
            </Shared::Ui::Button>
          </Shared::Ui::Button>
        </li>
      {{/each}}
      {{#if @canAddNewLink}}
        {{! Add Link }}
        <li class="o--list__item u--p__0">
          <Shared::Ui::Button
            @additional="block"
            @class="u--p__lr__lg u--p__tb__md u--text--center u--text--hl qa--linkinbio_add_extra_link"
            @onClick={{@addLink}}
            @variant="unstyled"
          >
            {{svg-jar "add" class="o--icon--xs u--m__r__xs"}}
            {{t "linkinbio.multi_link.tag_new"}}
          </Shared::Ui::Button>
        </li>
      {{else}}
        {{! Maximum number of links: 5 }}
        <li class="o--list__item u--p__lr__lg u--p__tb__md u--text--center u--text--light">
          {{t "linkinbio.multi_link.max_items"}}
        </li>
      {{/if}}
    </ul>
  </section>
  */
  {
    "id": "xDHgV4NS",
    "block": "[[[11,\"section\"],[24,0,\"o--modalBody--secondary u--p__0 has--footer\"],[4,[38,0],null,null],[12],[1,\"\\n  \"],[10,\"ul\"],[14,0,\"u--listUnstyle\"],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,1]],null]],null],null,[[[1,\"      \"],[10,\"li\"],[14,0,\"o--list__item u--p__0\"],[12],[1,\"\\n        \"],[8,[39,3],null,[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"block\",\"cML--list__item\",[28,[37,4],[[30,0],[30,4],[30,2]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n          \"],[10,0],[14,0,\"cML--list__bullet\"],[12],[1,\"\\n            \"],[10,1],[14,0,\"cML--list__bullet--counter\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[[30,3],1],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[8,[39,3],null,[[\"@class\",\"@onClick\",\"@variant\"],[\"cML--list__bullet--action qa--linkinbio_delete_link u--hide--mobile\",[28,[37,4],[[30,0],[30,5],[30,2]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,6],[\"trash\"],[[\"class\"],[\"o--icon qa--linkinbio_delete_icon\"]]]],[1,\"\\n            \"]],[]]]]],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,\"h4\"],[14,0,\"o--list__title u--ellipsis\"],[12],[1,\"\\n            \"],[1,[30,2,[\"title\"]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[14,0,\"o--list__text\"],[12],[1,\"\\n            \"],[1,[30,2,[\"linkUrl\"]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,3],[14,0,\"o--list__action u--text--uppercase\"],[12],[1,\"\\n            \"],[1,[28,[35,7],[\"shared_words.edit\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[8,[39,3],null,[[\"@class\",\"@onClick\",\"@variant\"],[\"cML--list__bullet--mobAction qa--linkinbio_delete_link u--hide--desktop o--list__action\",[28,[37,4],[[30,0],[30,5],[30,2]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,6],[\"trash\"],[[\"class\"],[\"o--icon qa--linkinbio_delete_icon\"]]]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[2,3]],null],[41,[30,6],[[[1,\"      \"],[10,\"li\"],[14,0,\"o--list__item u--p__0\"],[12],[1,\"\\n        \"],[8,[39,3],null,[[\"@additional\",\"@class\",\"@onClick\",\"@variant\"],[\"block\",\"u--p__lr__lg u--p__tb__md u--text--center u--text--hl qa--linkinbio_add_extra_link\",[30,7],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,6],[\"add\"],[[\"class\"],[\"o--icon--xs u--m__r__xs\"]]]],[1,\"\\n          \"],[1,[28,[35,7],[\"linkinbio.multi_link.tag_new\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,\"li\"],[14,0,\"o--list__item u--p__lr__lg u--p__tb__md u--text--center u--text--light\"],[12],[1,\"\\n        \"],[1,[28,[35,7],[\"linkinbio.multi_link.max_items\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@links\",\"multiLink\",\"index\",\"@editLink\",\"@toggleDeleteLink\",\"@canAddNewLink\",\"@addLink\"],false,[\"perfect-scroll\",\"each\",\"-track-array\",\"shared/ui/button\",\"action\",\"add\",\"svg-jar\",\"t\",\"if\"]]",
    "moduleName": "shared/components/shared/linkinbio/list/multi-link.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});